import * as React from "react";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import spreadsheet from "../../iconic/spreadsheet.svg";

interface IExportButtonProps extends ITranslationProps {
    onClick: () => void;
}

function ExportButton(p: IExportButtonProps) {
    return (
        <a href="#" onClick={p.onClick} >
            {p.t("Global.ExportToCSV")}
            <img className="ml-2 mb-1 button-icon" src={spreadsheet} />
        </a>
    );
}

export default translateComponent(ExportButton);



// WEBPACK FOOTER //
// ./src/core/ExportButton/ExportButton.tsx